export const WEEKDAY_GET = 'weekDayGet'
export const WEEKDAYS_GET = 'weekDaysGet'
